import React from 'react';
export default function Alert(props) {
  return (
    <svg
      className={props.className}
      onClick={props.onClick}
      viewBox='0 0 17 17'
    >
      <g
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <g
          transform='translate(-907.000000, -954.000000)'
          fill='#C73500'
          fillRule='nonzero'
        >
          <path
            d='M915.49998,970.859371 C920.04737,970.859371 923.734335,967.173735 923.734335,962.625015 C923.734335,958.078954 920.04737,954.39066 915.49998,954.39066 C910.952589,954.39066 907.265624,958.078954 907.265624,962.625015 C907.265624,967.173735 910.952589,970.859371 915.49998,970.859371 Z M915.49998,969.796873 C911.540711,969.796873 908.328122,966.590736 908.328122,962.625015 C908.328122,958.667108 911.535588,955.453157 915.49998,955.453157 C919.438561,955.453157 922.671838,958.643146 922.671838,962.625015 C922.671838,966.58584 919.46408,969.796873 915.49998,969.796873 Z M915.649037,964.75001 C915.862652,964.75001 916.038232,964.581595 916.047117,964.368175 L916.279538,958.790063 C916.288974,958.563673 916.107978,958.375025 915.881458,958.375025 L915.118469,958.375025 C914.891917,958.375025 914.710986,958.563673 914.720357,958.790063 L914.952778,964.368175 C914.961695,964.581563 915.137308,964.75001 915.35089,964.75001 L915.649037,964.75001 Z M915.49998,967.273442 C916.013427,967.273442 916.429665,966.857204 916.429665,966.343756 C916.429665,965.830309 916.013427,965.414071 915.49998,965.414071 C914.986532,965.414071 914.570294,965.830309 914.570294,966.343756 C914.570294,966.857204 914.986532,967.273442 915.49998,967.273442 Z'
          ></path>
        </g>
      </g>
    </svg>
  );
}
